// extracted by mini-css-extract-plugin
module.exports = {"container":"e_8B","hoverContainer":"e_9B","tooltip":"e_-B","active":"e_aC","head":"e_bC","text":"e_cC"};